import { render, staticRenderFns } from "./NotificationVerifyEmail.vue?vue&type=template&id=181609fe&scoped=true"
import script from "./NotificationVerifyEmail.vue?vue&type=script&lang=js"
export * from "./NotificationVerifyEmail.vue?vue&type=script&lang=js"
import style0 from "./NotificationVerifyEmail.vue?vue&type=style&index=0&id=181609fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181609fe",
  null
  
)

export default component.exports